import api from '../axios/axiosInstance';

export interface RegisterResponse {
  _id: string;
  email: string;
  name: string;
  roles: string[];
  country: string;
  access_token: string;
  refresh_token: string;
  deviceHasPOS: boolean;
  userPosCount: number;
}

const register = async (data: {
  email: string;
  password: string;
  name: string;
}): Promise<RegisterResponse> => {
  const response = await api.post('/users/register', data);
  return response.data;
};

export default register;
